export const JMsolutionCategories = [
  { name: "Mask Pack", link: "/maskpack" },
  { name: "toner/toner pad", link: "/toner" },
  // "Mask Pack",
  // "toner/toner pad",
  //   "Essence/Ampoule",
  //   "cream",
  //   "cleansing",
  //   "sun care",
];

export const carenelCategories = [
  {
    name: "lip care",
    link: "/lipcare",
    products: [
      {
        name: "Berry Lip Night Mask",
        image:
          "https://carenel.com/web/product/medium/berry_lip_night_mask.jpg",
        price: "19,000 ks",
      },
      {
        name: "Pomegranate Lip Night Mask",
        image:
          "https://carenel.com/web/product/medium/Pomegranate_lip_night_mask.jpg",
        price: "19,000 ks",
      },
      {
        name: "Berry Lip Night Mask",
        image:
          "https://carenel.com/web/product/medium/berry_lip_night_mask_5g.jpg",
        price: "17,700 ks",
      },
      {
        name: "Pomegranate Lip Night Mask",
        image:
          "https://carenel.com/web/product/medium/pomegranate_lip_night_mask_5g.jpg",
        price: "17,700 ks",
      },
      {
        name: "Lime Lip Night Mask",
        image:
          "https://carenel.com/web/product/medium/lime_lip_night_mask_5g.jpg",
        price: "17,700 ks",
      },
      {
        name: "Lip Night Mask 5g [Berry+Pomegranate+Lime]",
        image: "https://carenel.com/web/product/medium/lip_night_mask_5g.jpg",
        price: " 17,700 ks",
      },
    ],
  },
  { name: "skin care", link: "/skincare" },
  // "lip care",
  // "skin care",
  //   "make up",
  //   "hair & body",
];

export const innisfreeCategories = [
  { name: "Cleanser", link: "/cleanser" },
  { name: "Serum", link: "/serum" },
  // "Cleanser",
  // "Serum",
  //   "Moisturizer",
  //   "UV Protection",
  //   "Masks",
];

export const hotProducts = [
  {
    name: "Berry Lip Night Mask",
    price: "19,000 K",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcarenel_hot1.jpg?alt=media&token=1b54285f-d24b-45a2-969c-69c81abf88c7",
  },
  {
    name: "Glow Peel Spa Cream",
    price: "10,900 K",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot1.jpg?alt=media&token=e8014c2d-4360-44f6-9296-5fbb82259cd8",
  },
  {
    name: "Green Tea Hyaluronic Acid Serum",
    price: "30, 000 K",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Finnisfree_hot1.webp?alt=media&token=43698403-453b-4160-a7c0-39d2dbbb7949",
  },
  {
    name: "Nature Sun Cream",
    price: "16,900 K",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot2.jpg?alt=media&token=b18759de-d7d8-4153-bb2c-215490f706c98",
  },
];

export const newProducts = [
  {
    name: "Pore Clearing Clay Mask 2X",
    price: "16, 000 K",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/CA_231171045-20210223_INNISFREE-006_1080_Resized_772x.jpg?v=1672758000",
  },
  {
    name: "Daily UV Defense Sunscreen",
    price: "5000 K",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_DUV_Product_2023_02Cropped-1080x1080.jpg?v=1675089004&width=304",
  },
  {
    name: "릴리프 약산성 약쑥 마스크 (10pcs)",
    price: "3000 K",
    image:
      "https://jmsolution.com/web/product/medium/202211/524dcd7096e2fbf3e7b0992b9dab5350.png",
  },
  {
    name: "Nature Sun Cream",
    price: "16,900 K",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fjm_hot2.jpg?alt=media&token=b18759de-d7d8-4153-bb2c-215490f706c98",
  },
];

export const adminCollections = [
  {
    name: "Vita Deepair Ampoule",
    price: "19,900 K",
    image:
      "https://jmsolution.com/web/product/big/202211/b9df1999f39c2d1b070d9b3eaa10d504.png",
  },
  {
    name: "Youth Enhancing Serum",
    price: "50, 000 K",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_BTS_Product_02Cropped_1080x1080_34250e27-fd47-4647-ac72-b8d670c5f415_772x.jpg?v=1675089047",
  },
  {
    name: "릴리프 약산성 약쑥 마스크 (10pcs)",
    price: "30, 000 K",
    image:
      "https://jmsolution.com/web/product/medium/202211/524dcd7096e2fbf3e7b0992b9dab5350.png",
  },
  {
    name: "Pore Clearing Clay Mousse Mask 2X",
    price: "16,900 K",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/231171114_PoreClearingClayMousseMask2X_1x1_c54439e1-fe51-4d66-a0d3-94c5c081d91d.jpg?v=1663252587&width=304",
  },
];

export const lipcare = [
  {
    name: "Berry Lip Night Mask",
    image: "https://carenel.com/web/product/medium/berry_lip_night_mask.jpg",
    price: "19,000 K",
  },
  {
    name: "Pomegranate Lip Night Mask",
    image:
      "https://carenel.com/web/product/medium/Pomegranate_lip_night_mask.jpg",
    price: "19,000 K",
  },
  {
    name: "Berry Lip Night Mask",
    image: "https://carenel.com/web/product/medium/berry_lip_night_mask_5g.jpg",
    price: " 17,700 K",
  },
  {
    name: "Pomegranate Lip Night Mask",
    image:
      "https://carenel.com/web/product/medium/pomegranate_lip_night_mask_5g.jpg",
    price: " 17,700 K",
  },
  {
    name: "Lime Lip Night Mask",
    image: "https://carenel.com/web/product/medium/lime_lip_night_mask_5g.jpg",
    price: " 17,700 K",
  },
  {
    name: "Lip Night Mask 5g [Berry+Pomegranate+Lime]",
    image: "https://carenel.com/web/product/medium/lip_night_mask_5g.jpg",
    price: " 17,700 K",
  },
];

export const skincare = [
  {
    name: "Freckles, blemishes, firmness and soothing 4 types set (Toner 155ml + Serum 30ml + Cream 40ml + Cleanser",
    image:
      "https://carenel.com/web/product/medium/202302/b923ffb7cddd76c029d25232c458a8b9.jpg",
    price: "19,000 K",
  },
  {
    name: "No Sebum Tone-up Sun Cream SPF50+/PA++++ 50ml + Wasong Capsule Deep Cleansing Foam 180ml 2 Piece Set",
    image:
      "https://carenel.com/web/product/medium/202302/475587f43bf206c328067397a478b1c4.jpg",
    price: "19,000 K",
  },
  {
    name: "Resilience strengthening soothing 3-piece set (Toner 155ml + Serum 30ml + Cream 40ml)",
    image:
      "https://carenel.com/web/product/medium/202302/45e709d9416e937b0bd4c0d5d17e14fa.jpg",
    price: " 17,700 K",
  },
  {
    name: "Cica Vita B5 Salicylic Acid Gentle Cleanser 150ml",
    image:
      "https://carenel.com/web/product/medium/cicavita_gentle_cleanser.jpg",
    price: " 17,700 K",
  },
  {
    name: "Cica Vita B5 Tranexamic Acid Toner 155ml",
    image: "https://carenel.com/web/product/medium/cicavita_toner.jpg",
    price: " 17,700 K",
  },
  {
    name: "Anti-Melasma Cica Cream 40ml",
    image: "https://carenel.com/web/product/medium/anti_melasma_cica_cream.jpg",
    price: " 17,700 K",
  },
];

export const cleanser = [
  {
    name: "Green Tea Amino Acid Face Cleanser",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_GTCF_Product_2023_01_1080x1080_bbbf6e0c-d541-44ce-95d6-f723f87e486c.jpg?v=1678893255&width=304",
    price: "19,000 K",
  },
  {
    name: "Pore Clearing Facial Foam",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_VFF_Product_2023_02_1080x1080_5b3ccaaf-2d17-43cc-ab71-40fadf2c18c0.jpg?v=1678287177&width=304",
    price: "19,000 K",
  },
  {
    name: "Dewy Glow Jam Cleanser",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/1080x1080-INNIS2-_0002_innisfree_jan_14_v3.jpg?v=1614289994&width=304",
    price: " 17,700 K",
  },
  {
    name: "Clarifying Cleansing Foam",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_Bija_CF_Product_01.jpg?v=1658426373&width=304",
    price: " 17,700 K",
  },
  {
    name: "Rebalancing Cleanser",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/2021_BLU_Cleanser_4x5_23117_GMCCropped.jpg?v=1669911179&width=304",
    price: " 17,700 K",
  },
  {
    name: "Green Tea Cleansing Oil",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_GTCO_Packshot_2022AD_01-1080x1080-v1.jpg?v=1669396770&width=304",
    price: " 17,700 K",
  },
];

export const serum = [
  {
    name: "Green Tea Hyaluronic Acid Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_GTSS_Product_2022AD_12-1080x1080-v1.jpg?v=1669075234&width=304",
    price: "19,000 K",
  },
  {
    name: "Retinol Cica Moisture Recovery Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_RCS_Product_2022_02_1x1Cropped_1080x1080_5d90a7ff-8691-4867-a4b3-5218d411fe0b.jpg?v=1675089109&width=304",
    price: "19,000 K",
  },
  {
    name: "Youth Enhancing Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_BTS_Product_02Cropped_1080x1080_34250e27-fd47-4647-ac72-b8d670c5f415.jpg?v=1675089047&width=304",
    price: " 17,700 K",
  },
  {
    name: "Brightening & Pore-caring Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/1080x1080-brightening_0004_231171121Brightening_Pore-caringSerum30ml_20.jpg?v=1643063279&width=304",
    price: " 17,700 K",
  },
  {
    name: "Brightening & Pore-caring Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/1080x1080-brightening_0004_231171121Brightening_Pore-caringSerum30ml_20.jpg?v=1643063279&width=304",
    price: " 17,700 K",
  },
  {
    name: "Clarifying Spot Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/IF_Bia_SS_Product_02.jpg?v=1658426139&width=304",
    price: " 17,700 K",
  },
  {
    name: "Gentle Care for Sensitive Skin Concentrated Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/231170241-Gentle-Care-for-Sensitive-Skin-Concentrated-Serum-510x510.png?v=1570204645&width=304",
    price: " 17,700 K",
  },
  {
    name: "Green Tea Hyaluronic Acid Eye Serum",
    image:
      "https://cdn.shopify.com/s/files/1/0089/3367/1012/products/HQ_IF_GTSES_Product_2022AD_01-1080x1080-v2.jpg?v=1669132443&width=304",
    price: " 17,700 K",
  },
];

export const maskpack = [
  {
    name: "Honey Luminous Royal Propolis Mask (10pcs)",
    image: "https://jmsolution.com/web/product/medium/202212/5fa4671ea8d2d675d35dba7838e7c854.png",
    price: "19,000 K",
  },
  {
    name: "Water Luminous SOS Ringer Mask Black (10pcs)",
    image:
      "https://jmsolution.com/web/product/big/202212/a6b74e4b2bd77ebc7601bef8322f4c13.jpg",
    price: "19,000 K",
  },
  {
    name: "Blue Light Marine Pearl Deep Moisture Mask Pearl (10pcs)",
    image: "https://jmsolution.com/web/product/big/202301/8ea44ceaf0bd67682ca78574f9e23845.png",
    price: " 17,700 K",
  },
  {
    name: "Relief Fit Hoseongcho Mask (10pcs)",
    image:
      "https://jmsolution.com/web/product/big/202206/b9295f05d48033c0860dcbfa9730035d.jpg",
    price: " 17,700 K",
  },
];

export const toner = [
  {
    name: "Vita Defair Toner",
    image: "https://jmsolution.com/web/product/medium/202211/5a0872787a4785f19aea3785524a8f50.png",
    price: "19,000 K",
  },
  {
    name: "Water Luminous SOS글로우 필 스파 토너",
    image:
      "https://jmsolution.com/web/product/medium/202206/15856facc6d0c1f0a48c9fb8346cf524.jpg",
    price: "19,000 K",
  },
  {
    name: "Blue Light Marine Pearl Deep Moisture Mask Pearl (10pcs)",
    image: "https://jmsolution.com/web/product/medium/202209/6552af0ebe18841f653f8a18ad4af748.jpg",
    price: " 17,700 K",
  },
  {
    name: "Relief Fit Hoseongcho Mask (10pcs)",
    image:
      "https://jmsolution.com/web/product/medium/202211/9f1e076f1a9572a7f966f4fb2c67cda1.jpg",
    price: " 17,700 K",
  },
];